<template>
  <div :class="[{ 'input-wrapper-with-icon': inputIconName }, classes]">
    <label v-if="showLabel" :for="label" :class="{ 'labelWrap': labelWrap }" >{{label}}</label>
    <span v-if="optional" class="input-optional"> {{ optional }}</span>
    <Icon
      v-if="labelIconName"
      class="label-icon"
      :class="{ 'cursor' : emitLabelClick }"
      :name="labelIconName"
      @click="clickIcon"
    />
    <Icon
      v-if="inputIconName"
      :name="inputIconName"
      :class="{ 'cursor' : emitLabelClick }"
      @click="clickIcon"/>
    <input
      :id="label"
      :disabled="disabled"
      :type="type"
      @blur="$emit('blur')"
      :placeholder="placeholder"
      :class="{
        'error-input': errorMessage,
        'iconLeft': hasIcon,
        'iconRight': hasIconRight
      }"
      v-model="model"
      :inputmode="inputmode"
    />
    <div v-if="errorMessage" class="input-error-message">
      {{errorMessage}}
    </div>
  </div>
</template>

<script>
import Icon from '@/components/ui/AppIcon.vue';

export default {
  name: 'app-input',
  data: () => ({
    model: '',
  }),
  props: {
    value: {},
    hasIcon: {
      type: Boolean,
      default: false,
    },
    labelWrap: {
      type: Boolean,
      default: false,
    },
    hasIconRight: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      required: true,
    },
    optional: {
      type: String,
      default: '',
    },
    classes: {
      type: String,
      default: 'input-wrapper',
    },
    errorMessage: {
      type: String,
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inputIconName: {
      type: String,
      default: '',
    },
    labelIconName: {
      type: String,
      default: '',
    },
    emitLabelClick: {
      type: Boolean,
      default: false,
    },
    inputmode: {
      type: String,
      default: 'text',
    },
  },
  components: {
    Icon,
  },
  watch: {
    model(oldValue) {
      this.$emit('input', oldValue);
      this.$emit('input:unmasked', this.unmask(oldValue));
    },
  },
  methods: {
    unmask(maskedValue) {
      const defaultDelimiters = /[-!$%^&*()_+|~=`{}[\]:";'<>?,./\\ ]/;
      const unmaskText = (text) => (text
        ? String(text).replace(new RegExp(defaultDelimiters, 'g'), '')
        : text);
      return unmaskText(maskedValue);
    },
    clickIcon(evt) {
      if (this.emitLabelClick) this.$emit('clickIcon', evt);
    },
  },
  mounted() {
    this.model = this.value;
  },
};
</script>

<style lang="scss" scoped>
  .label-icon {
    margin-left: 4px;
  }

  .cursor {
    cursor: pointer;
  }

  .input-wrapper-with-icon {
    position:relative;

    input {
      padding-left: 40px;
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .iconLeft {
    padding-left: 48px;
  }

  .iconRight {
    padding-right: 48px;
  }

  .labelWrap {
    white-space: nowrap;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

</style>
